var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 133,
    viewBox: "0 0 132 133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12839",
    "data-name": "Group 12839",
    transform: "translate(907 -9726)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_390",
    "data-name": "Ellipse 390",
    cx: 66,
    cy: 66.5,
    rx: 66,
    ry: 66.5,
    transform: "translate(-907 9726)",
    fill: "#fdeebe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12659",
    "data-name": "Group 12659",
    transform: "translate(-1279 9754.035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4620",
    "data-name": "Path 4620",
    d: "M30.233,23.848V10L6,34.233,30.233,58.467V44.273c17.31,0,29.426,5.539,38.081,17.656C64.853,44.619,54.467,27.31,30.233,23.848Z",
    transform: "translate(401 3)",
    fill: "#4c5b71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/Share.2910927c7de4d504b1330a6543defb8a.svg";
export { ForwardRef as ReactComponent };